export default __webpack_public_path__ + "static/media/phone.b182d909.svg";